import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  // Your Firebase configuration object goes here
  // You'll need to replace this with your actual Firebase config
  apiKey: "AIzaSyBS4ZUOOe4NUvqb0hME2vRavmRWlp-NVRo",
  authDomain: "re-calc-5feb4.firebaseapp.com",
  projectId: "re-calc-5feb4",
  storageBucket: "re-calc-5feb4.firebasestorage.app",
  messagingSenderId: "571013777843",
  appId: "1:571013777843:web:90b8b9d3bb5da36b8663c6",
  measurementId: "G-BCC3LH9C0L"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
